import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'devise','auth','shop','alert','tracking_code','master',
      "floor","news","dashbord","printer","terminal",
    ],  // localStorageに保存したいstoreを入れる
  })(store);
};